import React from 'react';
import { PropertiesAdvancedFiltersComponent } from './PropertiesAdvancedFilters';
import type { PropertiesFilters } from './PropertiesAdvancedFilters';
import { Icon } from '@/shared/icons'
/**
 * Props do PropertiesFilterChipsBar
 */
export interface PropertiesFilterChipsBarProps {
  /** Filtros avançados atuais */
  filters: PropertiesFilters;
  /** Callback quando filtros mudam */
  onFiltersChange: (filters: PropertiesFilters) => void;
}

/**
 * Barra dedicada para exibir chips de filtros ativos de imóveis.
 *
 * Posicionada entre a FilterBar e o conteúdo (Grid/Table).
 * Contém os chips dos filtros aplicados, botão "+ Filtro" e botão "Limpar".
 *
 * @example
 * ```tsx
 * <PropertiesFilterChipsBar
 *   filters={advancedFilters}
 *   onFiltersChange={handleFiltersChange}
 * />
 * ```
 */
export const PropertiesFilterChipsBar: React.FC<PropertiesFilterChipsBarProps> = ({
  filters,
  onFiltersChange,
}) => {
  return (
    <div
      className="px-6 py-2 flex items-center gap-3"
      style={{
        backgroundColor: 'var(--theme-header-background)',
        borderBottom: '1px solid var(--theme-header-border)',
      }}
    >
      {/* Filter icon label */}
      <div
        className="flex items-center gap-1.5 flex-shrink-0"
        style={{ color: 'var(--theme-muted-text)' }}
      >
        <Icon name="filter" className="w-3.5 h-3.5" />
        <span className="text-xs font-medium">Filtros</span>
      </div>

      {/* Divider */}
      <div
        className="w-px h-5 flex-shrink-0"
        style={{ backgroundColor: 'var(--theme-header-border)' }}
      />

      {/* Chips + Add Filter + Clear */}
      <PropertiesAdvancedFiltersComponent
        filters={filters}
        onFiltersChange={onFiltersChange}
      />
    </div>
  );
};

PropertiesFilterChipsBar.displayName = 'PropertiesFilterChipsBar';
